import { View } from "binder"
import { StringViewModel } from "./string-viewModel"

export class StringView extends View<StringViewModel>{
    GetViewUniqueId(): string {
        return "V-A6B2AD55-A38A-4305-988F-995FF5FF14E3"
    }
    loadHtml(): string {
        let element = require('./string.html').default;
        let style = require('./string.less');
        return element;
    }
    constructor() {
       super();
    }
    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;
}
